module.exports = __webpack_public_path__ + "static/media/N-SOYMAS1.c3dc0ee9.jpg";